module.exports = __webpack_public_path__ + "img/personal_yearly.237be459.png";